module.exports = __webpack_public_path__ + "img/_2.0ce28aca.png";